BookingApp.service('ErrorServices',function(){
	var data;
	var msg = [];
	this.setError = function(response){
		//console.log(response);
		data = response.data
	}
	this.getData = function(){
		return data;
	}
});